import React, { useEffect } from "react";
import "./SrtTabs.css";
import Dickies from "./Dickies/Dickies";
import { Tabs } from "antd";
import Saucony from "./Saucony/Saucony";
import Eddie from "./Eddie Bauer/Eddie";
import MyFavoriteSocks from "./MyFavoriteSocks/MyFavoriteSocks";
import PdRedevelopment from "./PdRedevelopment/PdRedevelopment";
import {
  getSrtInitialList,
  getSrtUnsolicitedSamplesList,
  // resetMassFilter,
  resetMassUnsolicitedFilter,
  resetSeasonFilter,
  // resetSeasonFilter,
  // resetSrtData,
  resetSrtSeasonFilter,
  selectUnselectSrtTableRows,
  srtEXportArray,
  srtbrandName,
} from "../../Redux/actions/Srt/Srt";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SalesSamples from "./SalesSamples/SalesSamples";
import UnsolicitedSamples from "./UnsolicitedSamples/UnsolicitedSamples";
import HaggarBrand from "./Haggar/Haggar";
import DickiesUnderwear from "./DickiesUnderwear/DickiesUnderwear";
import NorthState from "./NorthState/NorthState";
import Inferno from "./Inferno/Inferno";
import TrueEnergy from "./TrueEnergy/TrueEnergy";
import NorthStateApparel from "./NorthStateApparel/NorthStateApparel";
import RunDry from "./RunDry/RunDry";
const { TabPane } = Tabs;

const SrtTabs = (containerRef) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [activeKey, setActiveKey] = useState(localStorage.getItem('srtActiveKey'))

  const path = location.pathname;

  const clearSrtAccordionSelections = () => {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("srtSelectedVendors_")) {
        localStorage.removeItem(key);
      }
    });
    localStorage.removeItem("srtSelectedExportKeys");
  };

  if (path.includes("/sample-receipt-tracker/dickies-socks")) {
    dispatch(srtbrandName("Dickies Socks"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Socks",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    localStorage.setItem("currentPage", 0);
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/saucony")) {
    dispatch(srtbrandName("Saucony"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Saucony",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    localStorage.setItem("currentPage", 0);
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/eddie-bauer")) {
    dispatch(srtbrandName("EddieBauer"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "EddieBauer",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    localStorage.setItem("currentPage", 0);
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/pd")) {
    dispatch(srtbrandName("PD"));
    localStorage.setItem("currentPage", 0);
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "PD",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/haggar")) {
    dispatch(srtbrandName("Haggar"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Haggar",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/sales-samples")) {
    dispatch(srtbrandName(""));
    // dispatch(getSrtInitialList("", "", "", "", 1, "", 1, 10));
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/unsolicited-samples")) {
    dispatch(srtbrandName(""));
    // dispatch(getSrtUnsolicitedSamplesList(1, 10));
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/dickies-underwear")) {
    dispatch(srtbrandName("Dickies Underwear"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Underwear",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/my-favorite-socks")) {
    dispatch(srtbrandName("My Favorite Socks"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Underwear",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path === "/sample-receipt-tracker/north-state") {
    dispatch(srtbrandName("NorthState"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Underwear",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/inferno")) {
    dispatch(srtbrandName("Inferno"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Underwear",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/true-energy")) {
    dispatch(srtbrandName("True Energy"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Underwear",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/north-state-apparel")) {
    dispatch(srtbrandName("North State Apparel"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Underwear",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  } else if (path.includes("/sample-receipt-tracker/run-dry")) {
    dispatch(srtbrandName("RunDry"));
    // dispatch(
    //   getSrtInitialList(
    //     srtDataForApi?.brand ? srtDataForApi?.brand : "Dickies Underwear",
    //     srtDataForApi?.style ? srtDataForApi?.style : "",
    //     srtDataForApi?.factory ? srtDataForApi?.factory : "",
    //     srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
    //     0,
    //     srtDataForApi?.season ? srtDataForApi?.season : "",
    //     1,
    //     10
    //   )
    // );
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
  }
  else {
    // dispatch(resetSrtData([]));
    // dispatch(resetMassFilter());
    // dispatch(resetSeasonFilter());
    dispatch(resetSrtSeasonFilter());
    dispatch(resetMassUnsolicitedFilter([]));
    dispatch(srtbrandName("Dickies Underwear"));
  }

  useEffect(() => {
    localStorage.setItem("activeKey", "3");
    if (path === "/sample-receipt-tracker/dickies-socks") {
      localStorage.setItem("srtActiveKey", "1");
    }
    if (path === "/sample-receipt-tracker/saucony") {
      localStorage.setItem("srtActiveKey", "2");
    }
    if (path == "/sample-receipt-tracker/eddie-bauer") {
      localStorage.setItem("srtActiveKey", "3");
    }
    if (path == "/sample-receipt-tracker/pd") {
      localStorage.setItem("srtActiveKey", "4");
    }
    if (path == "/sample-receipt-tracker/haggar") {
      localStorage.setItem("srtActiveKey", "5");
    }
    if (path == "/sample-receipt-tracker/sales-samples") {
      localStorage.setItem("srtActiveKey", "6");
    }
    if (path == "/sample-receipt-tracker/unsolicited-samples") {
      localStorage.setItem("srtActiveKey", "7");
    }
    if (path == "/sample-receipt-tracker/dickies-underwear") {
      localStorage.setItem("srtActiveKey", "8");
    }
    if (path == "/sample-receipt-tracker/my-favorite-socks") {
      localStorage.setItem("srtActiveKey", "9");
    }
    if (path == "/sample-receipt-tracker/north-state") {
      localStorage.setItem("srtActiveKey", "10");
    }
    if (path == "/sample-receipt-tracker/inferno") {
      localStorage.setItem("srtActiveKey", "11");
    }
    if (path == "/sample-receipt-tracker/true-energy") {
      localStorage.setItem("srtActiveKey", "12");
    }
    if (path == "/sample-receipt-tracker/north-state-apparel") {
      localStorage.setItem("srtActiveKey", "13");
    }
    if (path == "/sample-receipt-tracker/run-dry") {
      localStorage.setItem("srtActiveKey", "14");
    }
  }, [path]);

  const onKeyChange = (key) => {
    clearSrtAccordionSelections();

    if (key == 1) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "Dickies Socks",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(getSrtInitialList("Dickies Socks", "", "", "", 0, "", 1, 100));
      localStorage.removeItem("srtMassData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      localStorage.removeItem("unsolicitedMassFilterData");
      navigate("/sample-receipt-tracker/dickies-socks?page=1&pageSize=100");
      localStorage.setItem("srtActiveKey", "1");
      dispatch(srtbrandName("Dickies Socks"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 2) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "Saucony",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(getSrtInitialList("Saucony", "", "", "", 0, "", 1, 100));
      localStorage.removeItem("srtMassData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      navigate("/sample-receipt-tracker/saucony?page=1&pageSize=100");
      localStorage.removeItem("unsolicitedMassFilterData");
      localStorage.setItem("srtActiveKey", "2");
      dispatch(srtbrandName("Saucony"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 3) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "EddieBauer",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      localStorage.removeItem("srtMassData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      localStorage.removeItem("unsolicitedMassFilterData");
      navigate("/sample-receipt-tracker/eddie-bauer?page=1&pageSize=100");
      dispatch(getSrtInitialList("EddieBauer", "", "", "", 0, "", 1, 100));
      localStorage.setItem("srtActiveKey", "3");
      dispatch(srtbrandName("EddieBauer"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 4) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "PD",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      localStorage.removeItem("srtMassData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      navigate("/sample-receipt-tracker/pd?page=1&pageSize=100");
      localStorage.removeItem("unsolicitedMassFilterData");
      dispatch(getSrtInitialList("PD", "", "", "", 0, "", 1, 100));
      localStorage.setItem("srtActiveKey", "4");
      dispatch(srtbrandName("PD"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 5) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "Haggar",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      localStorage.removeItem("srtMassData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      localStorage.removeItem("unsolicitedMassFilterData");
      navigate("/sample-receipt-tracker/haggar?page=1&pageSize=10");
      dispatch(getSrtInitialList("Haggar", "", "", "", 0, "", 1, 10));
      localStorage.setItem("srtActiveKey", "5");
      dispatch(srtbrandName("Haggar"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 6) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 1,
          season: "",
        })
      );
      navigate("/sample-receipt-tracker/sales-samples?page=1&pageSize=100");
      dispatch(getSrtInitialList("", "", "", "", 1, "", 1, 100));
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      dispatch(resetSrtData([]));
      localStorage.removeItem("unsolicitedMassFilterData");
      localStorage.removeItem("srtData");
      dispatch(srtbrandName(""));
      localStorage.setItem("srtActiveKey", "6");
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      dispatch(resetMassFilter());
      dispatch(resetSrtData([]));
      dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 7) {
      navigate(
        "/sample-receipt-tracker/unsolicited-samples?page=1&pageSize=100"
      );
      localStorage.removeItem("unsolicitedMassFilterData");
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(getSrtUnsolicitedSamplesList(1, 100));
      // localStorage.removeItem("srtData");
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("massFilterData");
      localStorage.setItem("srtActiveKey", "7");
      dispatch(srtbrandName(""));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 8) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "Dickies Underwear",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(
        getSrtInitialList("Dickies Underwear", "", "", "", 0, "", 1, 10)
      );
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("unsolicitedMassFilterData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      navigate("/sample-receipt-tracker/dickies-underwear?page=1&pageSize=10");
      localStorage.setItem("srtActiveKey", "8");
      dispatch(srtbrandName("Dickies Underwear"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 9) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "My Favorite Socks",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(
        getSrtInitialList("My Favorite Socks", "", "", "", 0, "", 1, 100)
      );
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("unsolicitedMassFilterData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      navigate("/sample-receipt-tracker/my-favorite-socks?page=1&pageSize=100");
      localStorage.setItem("srtActiveKey", "9");
      dispatch(srtbrandName("My Favorite Socks"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 10) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "NorthState",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(
        getSrtInitialList("NorthState", "", "", "", 0, "", 1, 100)
      );
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("unsolicitedMassFilterData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      navigate("/sample-receipt-tracker/north-state?page=1&pageSize=100");
      localStorage.setItem("srtActiveKey", "10");
      dispatch(srtbrandName("NorthState"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 11) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "Inferno",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(
        getSrtInitialList("Inferno", "", "", "", 0, "", 1, 100)
      );
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("unsolicitedMassFilterData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      navigate("/sample-receipt-tracker/inferno?page=1&pageSize=100");
      localStorage.setItem("srtActiveKey", "11");
      dispatch(srtbrandName("Inferno"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 12) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "True Energy",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(
        getSrtInitialList("True Energy", "", "", "", 0, "", 1, 100)
      );
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("unsolicitedMassFilterData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      navigate("/sample-receipt-tracker/true-energy?page=1&pageSize=100");
      localStorage.setItem("srtActiveKey", "12");
      dispatch(srtbrandName("True Energy"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    } else if (key == 13) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "North State Apparel",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(
        getSrtInitialList("North State Apparel", "", "", "", 0, "", 1, 100)
      );
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("unsolicitedMassFilterData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      navigate("/sample-receipt-tracker/north-state-apparel?page=1&pageSize=100");
      localStorage.setItem("srtActiveKey", "13");
      dispatch(srtbrandName("North State Apparel"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    }
    else if (key == 14) {
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "RunDry",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
          season: "",
        })
      );
      dispatch(
        getSrtInitialList("RunDry", "", "", "", 0, "", 1, 100)
      );
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("unsolicitedMassFilterData");
      // localStorage.removeItem("srtData");
      localStorage.removeItem("massFilterData");
      // localStorage.removeItem("DashboardData");
      navigate("/sample-receipt-tracker/run-dry?page=1&pageSize=100");
      localStorage.setItem("srtActiveKey", "14");
      dispatch(srtbrandName("RunDry"));
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSrtData([]));
      // dispatch(resetMassFilter());
      // dispatch(resetSeasonFilter());
      dispatch(resetSrtSeasonFilter());
      dispatch(resetMassUnsolicitedFilter([]));
    }
  };

  const activeKey = localStorage.getItem("srtActiveKey");

  return (
    <div className="srt-tabs">
      <Tabs
        activeKey={activeKey ? activeKey : "1"}
        onChange={onKeyChange}
        destroyInactiveTabPane
      >
        <TabPane
          className="tab-one"
          tab={<div className="tab-one-background">DICKIES</div>}
          key={"1"}
        >
          <Dickies containerRef={containerRef}/>
        </TabPane>
        {/* <TabPane
          tab={<div className="tab-two-background">SAUCONY</div>}
          key={"2"}
        >
          <Saucony containerRef={containerRef}/>
        </TabPane> */}
        <TabPane
          tab={<div className="tab-three-background">EB</div>}
          key={"3"}
        >
          <Eddie containerRef={containerRef}/>
        </TabPane>
        <TabPane
          tab={<div className="tab-four-background">PD</div>}
          key={"4"}
        >
          <PdRedevelopment containerRef={containerRef}/>
        </TabPane>
        {/* <TabPane
          tab={<div className="tab-five-background">HAGGAR</div>}
          key={"5"}
        >
          <HaggarBrand containerRef={containerRef}/>
        </TabPane> */}
        <TabPane
          tab={<div className="tab-six-background">SALES SAMPLES</div>}
          key={"6"}
        >
          <SalesSamples containerRef={containerRef}/>
        </TabPane>
        <TabPane
          tab={<div className="tab-seven-background">UNSOLICITED</div>}
          key={"7"}
        >
          <UnsolicitedSamples containerRef={containerRef}/>
        </TabPane>
        {/* <TabPane
          tab={<div className="tab-eight-background">DICKIES UNDERWEAR</div>}
          key={"8"}
        >
          <DickiesUnderwear />
        </TabPane> */}
        <TabPane
          tab={<div className="tab-nine-background">MFS</div>}
          key={"9"}
        >
          <MyFavoriteSocks containerRef={containerRef}/>
        </TabPane>
        <TabPane
          tab={<div className="tab-ten-background">NORTHSTATE</div>}
          key={"10"}
        >
          <NorthState containerRef={containerRef}/>
        </TabPane>
        {/* <TabPane
          tab={<div className="tab-eleven-background">INFERNO</div>}
          key={"11"}
        >
          <Inferno containerRef={containerRef}/>
        </TabPane> */}
        <TabPane
          tab={<div className="tab-twelve-background">TRUE ENERGY</div>}
          key={"12"}
        >
          <TrueEnergy containerRef={containerRef}/>
        </TabPane>
        <TabPane
          tab={<div className="tab-thirteen-background">NORTHSTATE APPAREL</div>}
          key={"13"}
        >
          <NorthStateApparel containerRef={containerRef}/>
        </TabPane>
        <TabPane
          tab={<div className="tab-forteen-background">RUNDRY</div>}
          key={"14"}
        >
          <RunDry containerRef={containerRef}/>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SrtTabs;
